import { render } from "./MenuItemLocale.vue?vue&type=template&id=b333255a"
import script from "./MenuItemLocale.vue?vue&type=script&lang=js"
export * from "./MenuItemLocale.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__